export default "__VITE_ASSET__zdBVsnxn__"